import { SyntheticEvent, useEffect, useState } from 'react';

import {
  useFoldersShortQuery,
  useOrganizationsShortQuery,
} from '@common/cache';
import { useParams } from 'react-router-dom';
import {
  ReportFilters,
  reportTypeOptions,
} from '@views/pages/Reporting/Reports/types.ts';
import { ReportsFolderPreviewFilters } from '@views/pages/Reporting/ReportsFolderPreview/types.ts';

interface IUseActivityReportsTableFiltersProps {
  handleFilterChange: (
    newFilters: Partial<ReportsFolderPreviewFilters>,
  ) => void;
  filters: ReportsFolderPreviewFilters;
}

export const useReportsFolderPreviewTableFilters = ({
  filters,
  handleFilterChange,
}: IUseActivityReportsTableFiltersProps) => {
  const params = useParams();
  const [folder, setFolder] = useState<{ id: string; name: string } | null>(
    null,
  );
  const [org, setOrg] = useState<{ id: string; name: string } | null>(null);

  const { data: foldersNameList = [] } = useFoldersShortQuery();
  const { data: organizationList = [] } = useOrganizationsShortQuery();

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleFilterChange({
      search: e.target.value,
    });
  };

  const handleSelectFolder = (
    event: SyntheticEvent<Element, Event>,
    value: { id: string; name: string } | null,
  ) => {
    handleFilterChange({
      report_folder_id: value?.id,
    });
  };

  const handleSelectOrg = (
    event: SyntheticEvent<Element, Event>,
    value: { id: string; name: string } | null,
  ) => {
    setOrg(value);
  };

  const typeOptions = reportTypeOptions.map(o => ({
    id: o.value,
    name: o.label,
  }));

  const handleSelectType = (
    event: SyntheticEvent<Element, Event>,
    value: { id: string; name: string } | null,
  ) => {
    handleFilterChange({
      report_type: value?.id as ReportFilters['report_type'],
    });
  };

  useEffect(() => {
    if (params.folder_id) {
      const folder =
        foldersNameList.find(item => item.id === params.folder_id) || null;
      setFolder(folder);
      setOrg(folder?.organization || null);
    }
  }, [params, foldersNameList]);

  return {
    handleSearchChange,
    folderOptions: foldersNameList,
    handleSelectFolder,
    folder,
    org,
    report_type:
      typeOptions.find(item => filters.report_type === item.id) ?? null,
    typeOptions,
    handleSelectOrg,
    handleSelectType,
    organizationOptions: organizationList,
  };
};
